(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3195],{

/***/ 64667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ partners; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/index.ts
var DividerSection = __webpack_require__(85507);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/BecomeSegmentSelect/BecomeSegmentSelect.tsx





var copy = {
  heading: "Become a Twilio Segment Partner",
  description: "Twilio Segment gets your software and services in front of our growing user base of 25,000+ companies\u2014along with sales support, technical training, and personalized co-marketing opportunities."
};

var BecomeSegmentSelect = function BecomeSegmentSelect() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBaseStyled, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyText, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "h2",
            variant: "pLarge",
            children: copy.description
          })]
        })
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5hx3e42"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.segmentGreen[100];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;}" + ( true ? "" : 0));

var SectionBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e5hx3e41"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:0;}" + ( true ? "" : 0));

var StyledCopyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e5hx3e40"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}" + ( true ? "" : 0));

/* harmony default export */ var BecomeSegmentSelect_BecomeSegmentSelect = (BecomeSegmentSelect);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var components_Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/PartnersSelectImage.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Image = function Image(_ref) {
  var images = _ref.images,
      alt = _ref.alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? [240, 240] : _ref$size;

  var _size = (0,slicedToArray/* default */.Z)(size, 2),
      w = _size[0],
      h = _size[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat(images.webp, ", ").concat(images.webp2x, " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: w,
        height: h,
        src: images.png2x,
        alt: alt,
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hznupq0"
} : 0)( true ? {
  name: "nohnyt",
  styles: "display:flex;align-items:center;flex-direction:column;justify-content:center"
} : 0);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Integration.png
/* harmony default export */ var Integration = ("data:image/png;base64,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");
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Integration@2x.png
var Integration_2x = __webpack_require__(99078);
var Integration_2x_default = /*#__PURE__*/__webpack_require__.n(Integration_2x);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Integration.webp
/* harmony default export */ var assets_Integration = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Integration@2x.webp
var assets_Integration_2x = __webpack_require__(80962);
var assets_Integration_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Integration_2x);
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Channel.png
var Channel = __webpack_require__(45944);
var Channel_default = /*#__PURE__*/__webpack_require__.n(Channel);
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Channel@2x.png
var Channel_2x = __webpack_require__(14793);
var Channel_2x_default = /*#__PURE__*/__webpack_require__.n(Channel_2x);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Channel.webp
/* harmony default export */ var assets_Channel = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/assets/Channel@2x.webp
var assets_Channel_2x = __webpack_require__(67041);
var assets_Channel_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Channel_2x);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/PartnersSelect/PartnersSelect.tsx

















var techCopy = {
  heading: "Technology Partners",
  description: "Integrate your software with Segment. Grow your user base by joining the Twilio Segment Partner Program."
};
var techLink = {
  text: "Learn more",
  url: "/partners/integration/"
};
var channelCopy = {
  heading: "Channel Partners",
  description: "Help customers implement Segment. Develop new revenue streams by empowering your clients through customer data."
};
var channelLink = {
  text: "Learn more",
  url: "/partners/channel/"
};

var PartnersSelect = function PartnersSelect() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionStyled, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
      columns: 1,
      overrides: {
        md: 2
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Slot, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
          images: {
            png: Integration,
            png2x: (Integration_2x_default()),
            webp: assets_Integration,
            webp2x: (assets_Integration_2x_default())
          },
          alt: "Technology Partners"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: techCopy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          children: techCopy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(techLink.url, pageConfig),
          children: techLink.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Slot, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
          images: {
            png: (Channel_default()),
            png2x: (Channel_2x_default()),
            webp: assets_Channel,
            webp2x: (assets_Channel_2x_default())
          },
          alt: "Channel Partners"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: channelCopy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          children: channelCopy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(channelLink.url, pageConfig),
          children: channelLink.text
        })]
      })]
    })
  });
};

var Slot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eu2mnb71"
} : 0)( true ? "" : 0);

var SectionStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eu2mnb70"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:0;padding-top:0;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{padding:80px 120px 0;}}" + ( true ? "" : 0));

/* harmony default export */ var PartnersSelect_PartnersSelect = (PartnersSelect);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/AlreadyPartner/AlreadyAPartner.tsx





var AlreadyAPartner_copy = {
  heading: "Already a partner?"
};
var AlreadyAPartner_link = {
  text: "Log in to the partner portal",
  url: "https://partners.segment.com/English/"
};

var AlreadyAPartner = function AlreadyAPartner() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlreadyAPartner_SectionStyled, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      centered: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        children: AlreadyAPartner_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
        href: AlreadyAPartner_link.url,
        children: AlreadyAPartner_link.text
      })]
    })
  });
};

var AlreadyAPartner_SectionStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "etfmwnt0"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:0;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("lg");
}, "{padding-top:0;row-gap:40px;}}" + ( true ? "" : 0));

/* harmony default export */ var AlreadyPartner_AlreadyAPartner = (AlreadyAPartner);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/components/LookingForPartner/LookingForPartner.tsx


function LookingForPartner_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var LookingForPartner_copy = {
  heading: "Looking for a partner to help you implement Segment?"
};
var LookingForPartner_link = {
  text: "Find a Partner",
  url: "https://segment.partnerpage.io/"
};

var LookingForPartner = function LookingForPartner() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LookingForPartner_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
            children: LookingForPartner_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            href: LookingForPartner_link.url,
            color: "primary",
            size: "large",
            variant: "filled",
            children: LookingForPartner_link.text
          })]
        })
      })
    })
  });
};

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "elukamf2"
} : 0)("margin-bottom:24px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:40px;}" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "elukamf1"
} : 0)( true ? {
  name: "16oo1aq",
  styles: "max-width:684px;margin:0 auto"
} : 0);

var LookingForPartner_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elukamf0"
} : 0)( true ? "" : 0);

/* harmony default export */ var LookingForPartner_LookingForPartner = (LookingForPartner);
// EXTERNAL MODULE: ./src/views/Partners/LandingPage/assets/OgPartnersMain.jpg
var OgPartnersMain = __webpack_require__(74015);
var OgPartnersMain_default = /*#__PURE__*/__webpack_require__.n(OgPartnersMain);
;// CONCATENATED MODULE: ./src/views/Partners/LandingPage/Partners.tsx















var Partners_copy = {
  pageTitle: "Become a Twilio Segment Partner | Twilio Segment",
  pageDescription: "Join our trusted network of Twilio Segment digital consultants, agencies, and technology partners to grow your business while providing exceptional service to our joint customers."
};

var PartnersView = function PartnersView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: Partners_copy.pageTitle,
      pageDescription: Partners_copy.pageDescription,
      pageOG: (OgPartnersMain_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BecomeSegmentSelect_BecomeSegmentSelect, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PartnersSelect_PartnersSelect, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlreadyPartner_AlreadyAPartner, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSectionWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LookingForPartner_LookingForPartner, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var LogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1956knm1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";", LogoTiles_views/* TilesGridWrapper */.W, "{max-width:100%;}" + ( true ? "" : 0));

var DividerSectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1956knm0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:24px;padding-bottom:24px;}" + ( true ? "" : 0));

/* harmony default export */ var LandingPage_Partners = (PartnersView);
;// CONCATENATED MODULE: ./src/pages/partners/index.tsx



var Partners = function Partners() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPage_Partners, {});
};

/* harmony default export */ var partners = (Partners);

/***/ }),

/***/ 12795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(84949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 49749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 84949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(22624);

var _createClass = __webpack_require__(85458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(49749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 85507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DividerSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DividerSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52876);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 31561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners",
      function () {
        return __webpack_require__(64667);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(12795)


/***/ }),

/***/ 74015:
/***/ (function(module) {

module.exports = "/_next/static/images/OgPartnersMain-a3a95ea65611eb9ad08495534ad8e350.jpg";

/***/ }),

/***/ 45944:
/***/ (function(module) {

module.exports = "/_next/static/images/Channel-affacc60a6107d76cfbf7f8d1a688459.png";

/***/ }),

/***/ 14793:
/***/ (function(module) {

module.exports = "/_next/static/images/Channel@2x-09b54b3ddb23ca1a6b83406ab4c7777d.png";

/***/ }),

/***/ 99078:
/***/ (function(module) {

module.exports = "/_next/static/images/Integration@2x-7fba211fef67320d808fcc59c8f6f98f.png";

/***/ }),

/***/ 67041:
/***/ (function(module) {

module.exports = "/_next/static/images/Channel@2x-abc74ba627c5dc1e6996f063c81ccb22.webp";

/***/ }),

/***/ 80962:
/***/ (function(module) {

module.exports = "/_next/static/images/Integration@2x-ebdcbe47bf391b90b3f8d8a364e64c7f.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,6234,4136,2073,6784,8392,5735,2609,8187,442,9774,2888,179], function() { return __webpack_exec__(31561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);